import styled from 'styled-components';

import { colorTokens } from '../../../../../shared/components/variables';

export const DriverMarker = styled.div`
  position: relative;
  transition: all 200ms;
  margin-bottom: 36px;

  > svg {
    height: 54px;
    width: 27px;
    background: radial-gradient(rgba(70, 208, 239, 1), rgba(70, 208, 239, 0.5));
    border-radius: 25%;
    padding: 0;
    box-shadow: 0px 1px 15.9px 0px #92ebff;
    transform: rotate(180deg);
    flex-shrink: 0;
  }
`;

export const DriverStartMarker = styled.div`
  display: flex;
  width: 20.268px;
  height: 20.268px;
  padding: 4.222px 5.067px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8.445px;
  flex-shrink: 0;

  border-radius: 10.134px;
  border: 4px solid ${colorTokens.primary.main};
  background: ${colorTokens.primary.contrast};
`;
